export function specialDayKey(name: string): string {
	return name
		.normalize("NFD")
		.replace(/[̀-ͯ]/g, "")
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/^-+|-+$/g, "");
}

const TR_NAMES: Readonly<Record<string, string>> = {
	"new-year-s-day": "Yılbaşı",
	"new-year-s-eve": "Yılbaşı Arifesi",
	"new-year-holiday": "Yılbaşı Tatili",
	"christmas-day": "Noel",
	"christmas-eve": "Noel Arifesi",
	"boxing-day": "Noel Ertesi",
	"orthodox-christmas": "Ortodoks Noeli",
	"labour-day": "İşçi Bayramı",
	"labor-day": "İşçi Bayramı",
	"workers-day": "İşçi Bayramı",
	"international-workers-day": "Dünya İşçi Bayramı",
	"may-day": "1 Mayıs",
	"independence-day": "Bağımsızlık Günü",
	"easter-sunday": "Paskalya Pazarı",
	"easter-monday": "Paskalya Pazartesisi",
	"easter-saturday": "Paskalya Cumartesisi",
	easter: "Paskalya",
	"orthodox-easter": "Ortodoks Paskalyası",
	"good-friday": "Kutsal Cuma",
	"maundy-thursday": "Kutsal Perşembe",
	"holy-saturday": "Kutsal Cumartesi",
	"palm-sunday": "Palmiye Pazarı",
	"ash-wednesday": "Kül Çarşambası",
	"shrove-tuesday": "Karnaval Salısı",
	"end-of-ramadan-eid-al-fitr": "Ramazan Bayramı",
	"eid-al-fitr": "Ramazan Bayramı",
	"feast-of-the-sacrifice-eid-al-adha": "Kurban Bayramı",
	"eid-al-adha": "Kurban Bayramı",
	"first-day-of-ramadan": "Ramazan Başlangıcı",
	ramadan: "Ramazan",
	"birthday-of-muhammad-mawlid": "Mevlid Kandili",
	"eid-milad-un-nabi": "Mevlid Kandili",
	"islamic-new-year": "Hicri Yılbaşı",
	"day-of-ashura": "Aşure Günü",
	"laylat-al-mi-raj": "Miraç Kandili",
	"isra-and-mi-raj": "Miraç Kandili",
	"laylat-al-qadr": "Kadir Gecesi",
	"arafat-day": "Arefe Günü",
	"mother-s-day": "Anneler Günü",
	"father-s-day": "Babalar Günü",
	"children-s-day": "Çocuk Bayramı",
	"valentine-s-day": "Sevgililer Günü",
	"international-women-s-day": "Dünya Kadınlar Günü",
	"women-s-day": "Kadınlar Günü",
	"teacher-s-day": "Öğretmenler Günü",
	"student-s-day": "Öğrenciler Günü",
	"administrative-professionals-day": "Sekreterler Günü",
	assumption: "Meryem Ana'nın Göğe Kabulü",
	"all-saints-day": "Azizler Günü",
	"all-souls-day": "Ruhlar Günü",
	"immaculate-conception": "Günahsız Ana Bayramı",
	pentecost: "Pentikost",
	"whit-monday": "Pentikost Pazartesisi",
	"whit-sunday": "Pentikost Pazarı",
	"ascension-day": "Hz. İsa'nın Göğe Yükselişi",
	epiphany: "Epifani",
	"corpus-christi": "Corpus Christi",
	"trinity-sunday": "Teslis Pazarı",
	"reformation-day": "Reform Günü",
	"saint-martin": "Aziz Martin Günü",
	"saint-nicholas": "Aziz Nikola Günü",
	"saint-patrick-s-day": "Aziz Patrick Günü",
	"saint-joseph": "Aziz Yusuf Günü",
	"st-george-s-day": "Aziz Yorgi Günü",
	"saint-george-s-day": "Aziz Yorgi Günü",
	"saints-cyril-and-methodius-day": "Aziz Kiril ve Metodi Günü",
	"shrove-monday": "Karnaval Pazartesisi",
	"midsummer-day": "Yaz Ortası Günü",
	"europe-day": "Avrupa Günü",
	"songkran-festival": "Songkran Festivali",
	nauryz: "Nevruz",
	"defender-of-the-fatherland-day": "Vatan Savunucuları Günü",
	"struggle-for-freedom-and-democracy-day": "Özgürlük ve Demokrasi Mücadelesi Günü",
	"st-stephen-s-day": "Aziz Stephen Günü",
	"saint-stephen-s-day": "Aziz Stephen Günü",
	totensonntag: "Ölüler Pazarı",
	"day-of-prayer-and-repentance": "Dua ve Tövbe Günü",
	"national-day": "Milli Gün",
	"national-holiday": "Milli Bayram",
	"constitution-day": "Anayasa Günü",
	"republic-day": "Cumhuriyet Günü",
	"statehood-day": "Devlet Günü",
	"founding-day": "Kuruluş Günü",
	"national-foundation-day": "Milli Kuruluş Günü",
	"flag-day": "Bayrak Günü",
	"victory-day": "Zafer Günü",
	"liberation-day": "Kurtuluş Günü",
	"revolution-day": "Devrim Günü",
	"unity-day": "Birlik Günü",
	"freedom-day": "Özgürlük Günü",
	"emancipation-day": "Özgürlük Günü",
	"youth-day": "Gençlik Günü",
	"national-youth-day": "Milli Gençlik Günü",
	"martyrs-day": "Şehitler Günü",
	"heroes-day": "Kahramanlar Günü",
	"memorial-day": "Anma Günü",
	"remembrance-day": "Anma Günü",
	"armed-forces-day": "Silahlı Kuvvetler Günü",
	"army-day": "Ordu Günü",
	"armistice-day": "Ateşkes Günü",
	"veterans-day": "Gaziler Günü",
	"peace-day": "Barış Günü",
	"human-rights-day": "İnsan Hakları Günü",
	"family-day": "Aile Günü",
	"heritage-day": "Miras Günü",
	"africa-day": "Afrika Günü",
	"spring-festival": "Bahar Bayramı",
	carnival: "Karnaval",
	nowruz: "Nevruz",
	"chinese-new-year": "Çin Yeni Yılı",
	"mid-autumn-festival": "Sonbahar Ortası Festivali",
	"dragon-boat-festival": "Ejderha Teknesi Festivali",
	"qingming-festival": "Qingming Festivali",
	"vesak-day": "Vesak Günü",
	"buddha-s-birthday": "Buda'nın Doğum Günü",
	deepavali: "Diwali",
	diwali: "Diwali",
	holi: "Holi",
	"day-of-atonement-yom-kippur": "Yom Kippur (Kefaret Günü)",
	"yom-kippur": "Yom Kippur",
	"rosh-hashanah": "Roş Aşana",
	passover: "Pesah",
	hanukkah: "Hanuka",
	sukkot: "Sukot",
	purim: "Purim",
	shavuot: "Şavuot",
	"holocaust-remembrance-day": "Holokost Anma Günü",
	halloween: "Cadılar Bayramı",
	"thanksgiving-day": "Şükran Günü",
	"day-after-thanksgiving-day": "Şükran Günü Ertesi",
	"columbus-day": "Kolomb Günü",
	"martin-luther-king-jr-day": "Martin Luther King Jr. Günü",
	"washington-s-birthday": "Washington'ın Doğum Günü",
	juneteenth: "Juneteenth",
	"anzac-day": "Anzak Günü",
	"australia-day": "Avustralya Günü",
	"canada-day": "Kanada Günü",
	"bastille-day": "Bastille Günü",
	"german-unity-day": "Alman Birliği Günü",
	"national-sovereignty-and-children-s-day": "Ulusal Egemenlik ve Çocuk Bayramı",
	"commemoration-of-ataturk-youth-and-sports-day": "Atatürk'ü Anma, Gençlik ve Spor Bayramı",
	"democracy-and-national-unity-day": "Demokrasi ve Milli Birlik Günü",
	"national-mourning-day": "Milli Yas Günü",
	"orthodox-easter-monday": "Ortodoks Paskalya Pazartesisi",
	"day-of-the-martyrs": "Şehitler Günü",
	"proclamation-of-the-republic": "Cumhuriyet'in İlanı",
	"annunciation-anniversary-of-1821-revolution": "Müjde Yortusu ve 1821 Devrimi Yıl Dönümü",
	"national-heroes-day": "Milli Kahramanlar Günü",
	"saints-peter-and-paul": "Aziz Petrus ve Pavlus Günü",
	"public-holiday": "Resmî Tatil",
	"labour-and-solidarity-day": "Emek ve Dayanışma Günü",
	"defenders-of-ukraine-day": "Ukrayna Savunucuları Günü",
	"new-year": "Yeni Yıl",
	"language-martyrs-day": "Dil Şehitleri Günü",
	"mujib-s-birthday-children-s-day": "Mujib'in Doğum Günü ve Çocuk Bayramı",
	"bengali-new-year-s-day": "Bengal Yeni Yılı",
	"orthodox-epiphany": "Ortodoks Epifani",
	"national-unity-day": "Milli Birlik Günü",
	"saint-andrew-the-first-called-day": "İlk Çağrılan Aziz Andreas Günü",
	"saint-mary-s-day": "Meryem Ana Günü",
	"anniversary-of-the-green-march": "Yeşil Yürüyüş Yıl Dönümü",
	"anniversary-of-the-independence-manifesto": "Bağımsızlık Bildirgesi Yıl Dönümü",
	"feast-of-the-throne": "Taht Bayramı",
	"anniversary-of-the-recovery-oued-ed-dahab": "Oued Ed-Dahab'ın Kurtuluşu Yıl Dönümü",
	"anniversary-of-the-revolution-of-the-king-and-the-people": "Kral ve Halk Devrimi Yıl Dönümü",
	"national-police-day": "Polis Günü",
	"revolution-day-2011": "2011 Devrimi Günü",
	"sinai-liberation-day": "Sina'nın Kurtuluşu Günü",
	"sham-el-nessim": "Şam El Nesim (Bahar Bayramı)",
	"30-june-day": "30 Haziran Devrimi Günü",
	"finding-of-the-true-cross": "Kutsal Haç'ın Bulunuşu",
	"victory-at-adwa-day": "Adwa Zaferi Günü",
	"day-of-lament": "Yas Günü",
	"derg-downfall-day": "Derg'in Devrilişi Günü",
	"teachers-and-mentors-day": "Öğretmenler ve Eğitmenler Günü",
	"st-andrew-s-day": "Aziz Andreas Günü",
	"saint-john-the-baptist": "Vaftizci Yahya Günü",
	"day-of-the-unification-of-the-romanian-principalities": "Romen Prenslikleri'nin Birleşmesi Günü",
	"day-of-memory-and-honour": "Anma ve Onur Günü",
	"spring-and-labour-day": "Bahar ve İşçi Bayramı",
	"russia-day": "Rusya Günü",
	"magal-de-touba": "Touba Magal",
	"amazigh-new-year": "Amazig Yeni Yılı",
	"day-of-restoration-of-the-state-of-lithuania": "Litvanya Devleti'nin Yeniden Kuruluş Günü",
	"day-of-restoration-of-independence-of-lithuania": "Litvanya'nın Bağımsızlığını Yeniden Kazanma Günü",
	"st-john-s-day": "Aziz Yahya Günü",
	"national-language-day": "Milli Dil Günü",
	"durga-puja": "Durga Puja",
	"krishna-janmashtami": "Krishna Janmashtami",
	svetitskhovloba: "Svetitskhovloba",
	bedoba: "Bedoba",
	"orthodox-new-year": "Ortodoks Yeni Yılı",
	"ash-sunday": "Kül Pazarı",
	"tax-day": "Vergi Günü",
	"kwame-nkrumah-memorial-day": "Kwame Nkrumah Anma Günü",
	"resistance-fighting-day": "Direniş Savaşı Günü",
	"slovenian-sports-day": "Sloven Spor Günü",
	"korean-thanksgiving": "Kore Şükran Bayramı (Chuseok)",
	"defense-force-s-day": "Savunma Kuvvetleri Günü",
	"the-day-following-the-chinese-mid-autumn-festival": "Çin Sonbahar Ortası Festivali Ertesi",
	"feast-of-tabernacles-sukkot": "Sukot (Çardaklar Bayramı)",
	"binara-full-moon-poya-day": "Binara Dolunay Poya Günü",
	"st-wenceslas-day-czech-statehood-day": "Aziz Wenceslas Günü (Çek Devlet Günü)",
	"boqueron-battle-victory-day": "Boquerón Savaşı Zafer Günü",
	"botswana-day": "Botsvana Günü",
	"boy-s-day": "Erkek Çocuklar Günü",
	"cyprus-independence-day": "Kıbrıs Bağımsızlık Günü",
	"gandhi-jayanti": "Gandhi Jayanti",
	"simchat-torah-shmini-atzeret": "Simha Tora / Şemini Atseret",
	"wine-day": "Şarap Günü",
	"national-day-of-saint-francis-of-assisi": "Assisili Aziz Francis Milli Günü",
	"peace-and-reconciliation-day": "Barış ve Uzlaşma Günü",
	"implantacao-da-republica": "Cumhuriyet'in Kuruluşu",
	"territory-day": "Toprak Günü",
	"memorial-day-for-the-martyrs-of-arad": "Arad Şehitlerini Anma Günü",
	"battle-of-angamos": "Angamos Deniz Savaşı",
	"hangul-day": "Hangul Günü",
	"translator-s-day": "Çevirmenler Günü",
	"moi-day": "Moi Günü",
	"capital-liberation-day": "Başkentin Kurtuluşu Günü",
	"white-sunday": "Beyaz Pazar",
	"bolivian-woman-s-day": "Bolivyalı Kadınlar Günü",
	"fiesta-nacional-de-espana": "İspanya Milli Bayramı",
	"day-of-indigenous-resistance": "Yerli Direnişi Günü",
	"king-bhumibol-adulyadej-memorial-day": "Kral Bhumibol Adulyadej Anma Günü",
	"mother-teresa-day": "Rahibe Teresa Günü",
	"national-day-of-remembrance-for-steadfast-clergy": "Sarsılmaz Din Adamlarını Anma Günü",
	"mashujaa-day": "Kahramanlar Günü (Mashujaa)",
	"vietnamese-women-s-day": "Vietnam Kadınlar Günü",
	"world-war-ii-serbian-victims-remembrance-day": "II. Dünya Savaşı Sırp Kurbanlarını Anma Günü",
	"rabin-day": "Rabin Günü",
	"day-of-the-macedonian-revolutionary-struggle": "Makedon Devrim Mücadelesi Günü",
	"king-chulalongkorn-day": "Kral Chulalongkorn Günü",
	"vap-full-moon-poya-day": "Vap Dolunay Poya Günü",
	"sovereignty-day": "Egemenlik Günü",
	"last-monday-in-october": "Ekim'in Son Pazartesisi",
	"independent-czechoslovak-state-day": "Bağımsız Çekoslovak Devleti Günü",
	"day-of-remembrance-for-the-dead": "Ölüleri Anma Günü",
	"arrival-of-indentured-labourers": "Sözleşmeli İşçilerin Gelişi",
	"independence-of-cuenca": "Cuenca'nın Bağımsızlığı",
	"separation-day-from-columbia": "Kolombiya'dan Ayrılma Günü",
	thanksgiving: "Şükran Günü",
	"colon-day": "Kolomb Günü",
	"gustavus-adolphus-day": "Gustav Adolf Günü",
	"deepavali-festival-day": "Diwali Festivali",
	divali: "Diwali",
	sigd: "Sigd",
	"iqbal-day": "İkbal Günü",
	"primer-grito-de-independencia": "İlk Bağımsızlık Çağrısı",
	"saint-martin-s-day": "Aziz Martin Günü",
	"st-martin-s-day": "Aziz Martin Günü",
	"martyrdom-of-fatima-zahara": "Hz. Fatıma'nın Şehadeti",
	"king-s-feast": "Kral Bayramı",
	"national-peace-day": "Milli Barış Günü",
	"day-of-declaration-of-sovereignty": "Egemenlik İlanı Günü",
	"ben-gurion-day": "Ben-Gurion Günü",
	"national-revival-day": "Milli Uyanış Günü",
	"discovery-of-puerto-rico": "Porto Riko'nun Keşfi",
	"vietnamese-teacher-s-day": "Vietnam Öğretmenler Günü",
	"alphabet-day": "Alfabe Günü",
	"rudolf-maister-day": "Rudolf Maister Günü",
	"il-full-moon-poya-day": "Il Dolunay Poya Günü",
	"journee-nationale-de-la-republique": "Cumhuriyet Milli Günü",
	"1-advent": "1. Advent",
	"william-tubman-s-birthday": "William Tubman'ın Doğum Günü",
	"restauracao-da-independencia": "Bağımsızlığın Yeniden Kazanılması",
	"freedom-and-democracy-day": "Özgürlük ve Demokrasi Günü",
	"farmers-day": "Çiftçiler Günü",
	"st-nicholas-eve": "Aziz Nikola Arifesi",
	"king-bhumibol-adulyadej-s-birthday": "Kral Bhumibol Adulyadej'in Doğum Günü",
	"2-advent": "2. Advent",
	"dia-de-la-constitucion-espanola": "İspanya Anayasa Günü",
	"saint-nicholas-day": "Aziz Nikola Günü",
	"earthquake-remembrance-day": "Deprem Anma Günü",
	"saint-clement-of-ohrid-day": "Ohrili Aziz Kliment Günü",
	"virgin-of-caacupe": "Caacupé Meryem Anası",
	"battle-of-ayacucho": "Ayacucho Savaşı",
	"nobel-day": "Nobel Günü",
	"venezuelan-air-force-day": "Venezuela Hava Kuvvetleri Günü",
	"jamhuri-day": "Jamhuri (Cumhuriyet) Günü",
	"3-advent": "3. Advent",
	"saint-lucy-s-day": "Aziz Lucia Günü",
	"martyred-intellectuals-day": "Şehit Aydınlar Günü",
	"kingdom-day": "Krallık Günü",
	"day-of-reconciliation": "Uzlaşma Günü",
	"accession-day": "Katılım Günü",
	"4-advent": "4. Advent",
	"tenth-of-tevet": "Tevet'in Onu (Oruç)",
	"birthday-of-imam-ali": "Hz. Ali'nin Doğum Günü",
	"national-defence-day": "Milli Savunma Günü",
	"unduvap-full-moon-poya-day": "Unduvap Dolunay Poya Günü",
	"quaid-e-azam-day": "Kaid-i Azam Günü",
	"the-first-weekday-after-christmas-day": "Noel Sonrası İlk İş Günü",
	"independence-and-unity-day": "Bağımsızlık ve Birlik Günü",
	"day-of-goodwill": "İyi Niyet Günü",
	"greater-poland-uprising-remebrence-day": "Büyük Polonya Ayaklanması Anma Günü",
	"international-solidarity-day-of-azerbaijanis": "Dünya Azerbaycanlıları Dayanışma Günü",
	"the-first-day-of-january": "1 Ocak",
	"2nd-day-of-the-new-year": "Yeni Yılın 2. Günü",
	"new-year-s-holiday": "Yılbaşı Tatili",
	"pre-christmas-holidays": "Noel Öncesi Tatil",
	"anniversary-of-the-1966-upper-voltan-coup-d-etat": "1966 Yukarı Volta Darbesi Yıl Dönümü",
	"duruthu-full-moon-poya-day": "Duruthu Dolunay Poya Günü",
	"mabaas-of-muhammad": "Hz. Muhammed'in Peygamberliği",
	"coptic-christmas": "Kıpti Noeli",
	"fete-du-vodoun": "Vodun Bayramı",
	"birthday-of-eugenio-maria-de-hostos": "Eugenio María de Hostos'un Doğum Günü",
	"saint-knut-s-day": "Aziz Knut Günü",
	"tamil-thai-pongal-day": "Tamil Thai Pongal Günü",
	"anniversary-of-president-laurent-kabila": "Başkan Laurent Kabila'yı Anma",
	"anniversary-of-prime-minister-patrice-emery-lumumba": "Başbakan Patrice Lumumba'yı Anma",
	"thaipoosam-cavadee": "Thaipusam Kavadi",
	"errol-barrow-day": "Errol Barrow Günü",
	"grandmother-s-day": "Büyükanneler Günü",
	"plurinational-state-foundation-day": "Çokuluslu Devletin Kuruluş Günü",
	"grandfather-s-day": "Büyükbabalar Günü",
	"tu-bishvat-arbor-day": "Tu BiŞvat (Ağaç Bayramı)",
	"birthday-of-imam-mahdi": "İmam Mehdi'nin Doğum Günü",
	"laylat-al-bara-at": "Berat Kandili",
	"saint-sava-day": "Aziz Sava Günü",
	"kitchen-guardians": "Mutfak Koruyucuları",
	"memorial-day-of-the-republic": "Cumhuriyet Anma Günü",
	"st-brigid-s-day": "Aziz Brigid Günü",
	"navam-full-moon-poya-day": "Navam Dolunay Poya Günü",
	"abolition-of-slavery": "Köleliğin Kaldırılışı",
	"feast-of-the-virgin-of-candelaria": "Candelaria Meryem Anası Bayramı",
	"anniversary-of-the-tartu-peace-treaty": "Tartu Barış Antlaşması Yıl Dönümü",
	"communist-party-of-viet-nam-foundation-anniversary": "Vietnam Komünist Partisi Kuruluş Yıl Dönümü",
	"st-vartan-the-good-work-and-the-duty-days": "Aziz Vartan Günü",
	"women-s-carnival-day": "Kadınlar Karnavalı",
	"fat-thursday": "Yağlı Perşembe",
	"kashmir-day": "Keşmir Günü",
	"vietnamese-new-year-holidays": "Vietnam Yeni Yıl Tatili",
	"lunar-new-year-s-day": "Ay Takvimi Yeni Yılı",
	"chinese-spring-festival": "Çin Bahar Bayramı",
	"vietnamese-new-year": "Vietnam Yeni Yılı",
	"korean-new-year": "Kore Yeni Yılı",
	fastelavn: "Fastelavn (Karnaval)",
	"the-third-day-of-lunar-new-year": "Ay Yeni Yılının 3. Günü",
	"preseren-day-the-slovenian-cultural-holiday": "Prešeren Günü (Sloven Kültür Bayramı)",
	"feast-of-saint-paul-s-shipwreck-in-malta": "Aziz Pavlus'un Malta'da Karaya Oturuşu",
	"victory-of-ngoc-hoi-ong-a": "Ngọc Hồi-Đống Đa Zaferi",
	"anniversary-of-islamic-revolution": "İslam Devrimi Yıl Dönümü",
	"mahasivarathri-day": "Maha Şivaratri",
	"archbishop-janan-luwum-day": "Başpiskopos Janan Luwum Günü",
	"birthday-of-luis-munoz-marin": "Luis Muñoz Marín'in Doğum Günü",
	"polish-science-day": "Polonya Bilim Günü",
	"lantern-festival": "Fener Festivali",
	"mother-language-day": "Ana Dil Günü",
	"day-of-nuzul-al-quran": "Kur'an'ın İndirilişi Günü",
	"memorial-day-for-the-victims-of-the-communist-dictatorships": "Komünist Diktatörlük Kurbanlarını Anma Günü",
	"martyrdom-of-imam-ali": "Hz. Ali'nin Şehadeti",
	"granny-march-day": "Baba Marta Günü",
	"independence-movement-day": "Bağımsızlık Hareketi Günü",
	"national-cursed-soldiers-remembrance-day": "Lanetli Askerleri Anma Günü",
	"league-of-lezhe-day": "Leje Birliği Günü",
	"lailat-al-qadr": "Kadir Gecesi",
	"madin-full-moon-poya-day": "Madin Dolunay Poya Günü",
	"american-citizenship-day": "Amerikan Vatandaşlığı Günü",
	"maha-shivaratree": "Maha Şivaratri",
	vasaloppet: "Vasaloppet",
	"international-woman-s-day": "Dünya Kadınlar Günü",
	nyepi: "Nyepi (Sessizlik Günü)",
	korite: "Ramazan Bayramı (Korité)",
	"eid-ul-fitr": "Ramazan Bayramı",
	"id-el-fitr": "Ramazan Bayramı",
	"hari-raya-puasa": "Ramazan Bayramı",
	"holyday-for-fetr-eeid": "Ramazan Bayramı",
	"decoration-day": "Anma Günü",
	"men-s-day": "Erkekler Günü",
	"summer-day": "Yaz Günü",
	"native-language-day": "Ana Dil Günü",
	"j-j-robert-s-day": "J. J. Roberts Günü",
	"clean-monday": "Temiz Pazartesi",
	"st-patrick-s-day": "Aziz Patrick Günü",
	"nationalization-of-the-iranian-oil-industry": "İran Petrol Sanayisinin Millileştirilmesi",
	"id-ul-fitr-ramazan-festival-day": "Ramazan Bayramı",
	"first-day-of-spring-truant-s-day": "İlkbaharın İlk Günü",
	"sultan-nevruz-s-day": "Sultan Nevruz Günü",
	"tourism-week": "Turizm Haftası",
	"holy-week": "Kutsal Hafta",
	"day-of-the-sea": "Deniz Günü",
	"pakistan-day": "Pakistan Günü",
	"ugly-wednesday": "Çirkin Çarşamba",
	"national-day-for-the-remembrance-of-poles-rescuing-jews-under-german-occupation": "Yahudileri Kurtaran Polonyalıları Anma Günü",
	"genocide-remembrance-day": "Soykırımı Anma Günü",
	"the-day-following-good-friday": "Kutsal Cuma Ertesi",
	"catholic-easter": "Katolik Paskalyası",
	"april-fools-day": "1 Nisan Şaka Günü",
	"cyprus-national-day": "Kıbrıs Milli Günü",
	"islamic-republic-day": "İslam Cumhuriyeti Günü",
	"bak-full-moon-poya-day": "Bak Dolunay Poya Günü",
	"martyrdom-of-imam-jafar": "İmam Cafer'in Şehadeti",
	"sizdah-bedar": "Sizdebedar (Doğa Günü)",
	"ching-ming-festival": "Qingming Festivali",
	"chakri-memorial-day": "Chakri Anma Günü",
	"motherhood-and-beauty-day": "Annelik ve Güzellik Günü",
	ugadi: "Ugadi",
	"fast-and-prayer-day": "Oruç ve Dua Günü",
	"gesta-heroica-de-juan-santamaria": "Juan Santamaría Kahramanlık Günü",
	"day-before-sinhala-and-tamil-new-year": "Sinhala ve Tamil Yeni Yılı Arifesi",
	"ambedkar-jayanti": "Ambedkar Jayanti",
	"sinhala-and-tamil-new-year": "Sinhala ve Tamil Yeni Yılı",
	"baptism-of-poland-day": "Polonya'nın Vaftizi Günü",
	"memorial-day-for-the-victims-of-the-holocaust": "Holokost Kurbanlarını Anma Günü",
	"birthday-of-jose-de-diego": "José de Diego'nun Doğum Günü",
	"hung-kings-commemorations": "Hung Kralları Anma Günü",
	"american-samoa-flag-day": "Amerikan Samoası Bayrak Günü",
	"aliyah-day": "Aliya Günü",
	"warsaw-ghetto-uprising-remembrance-day": "Varşova Gettosu Ayaklanması Anma Günü",
	"landing-of-the-33-orientals": "33 Doğulu'nun Çıkarması",
	"declaration-of-independence": "Bağımsızlık Bildirgesi",
	"vietnam-book-day": "Vietnam Kitap Günü",
	"passover-pesach": "Pesah",
	pesach: "Pesah",
	"international-mother-earth-day": "Dünya Ana Toprak Günü",
	"great-prayer-day": "Büyük Dua Günü",
	"concord-day": "Uzlaşma Günü",
	"liberation-from-nazi-fascism-1945": "Nazi-Faşizminden Kurtuluş",
	"liberty-day": "Özgürlük Günü",
	"king-s-day": "Kral Günü",
	"day-of-uprising-against-occupation": "İşgale Karşı Ayaklanma Günü",
	"mimouna-seventh-day-of-passover": "Mimuna (Pesah'ın 7. Günü)",
	"orthodox-good-friday": "Ortodoks Kutsal Cuması",
	"day-of-liberating-the-south-for-national-reunification": "Güney'in Kurtuluşu ve Ulusal Birleşme Günü",
	staatsfeiertag: "Milli Bayram",
	"people-s-unity-day": "Halk Birliği Günü",
	"labour-day-and-vesak-full-moon-poya-day": "İşçi Bayramı ve Vesak Dolunay Poya Günü",
	"worker-s-day": "İşçi Bayramı",
	"2nd-day-of-the-labour-day": "İşçi Bayramı 2. Gün",
	"day-following-vesak-full-moon-poya-day": "Vesak Dolunay Poya Günü Ertesi",
	"coptic-easter": "Kıpti Paskalyası",
	"early-may-bank-holiday": "Mayıs Başı Tatili",
	"first-monday-in-may": "Mayıs'ın İlk Pazartesisi",
	"holocaust-remembrance-day-yom-hashoah": "Holokost Anma Günü (Yom HaŞoa)",
	"restoration-of-independence-day": "Bağımsızlığın Yeniden Kazanılması Günü",
	"remembrance-of-the-dead": "Ölüleri Anma",
	"coronation-day": "Taç Giyme Günü",
	"radio-and-television-day": "Radyo ve Televizyon Günü",
	"dien-bien-phu-victory-day": "Dien Bien Phu Zafer Günü",
	"yerkrapah-day": "Yerkrapah Günü",
	"national-victory-day": "Milli Zafer Günü",
	"day-of-victory-over-fascism": "Faşizme Karşı Zafer Günü",
	"victory-and-peace-day": "Zafer ve Barış Günü",
	"victory-in-europe-day": "Avrupa'da Zafer Günü",
	"fallen-soldiers-and-victims-of-terrorism-remembrance-day-yom-hazikaron": "Şehitleri Anma Günü (Yom HaZikaron)",
	"independence-day-yom-haatzmaut": "Bağımsızlık Günü (Yom HaAtzmaut)",
	"birthday-of-the-buddha": "Buda'nın Doğum Günü",
	"national-unification-day": "Milli Birleşme Günü",
	"whitsun-eve": "Pentikost Arifesi",
	tabaski: "Kurban Bayramı (Tabaski)",
	"id-el-kabir": "Kurban Bayramı",
	"hari-raya-haji": "Kurban Bayramı",
	"herzl-day": "Herzl Günü",
	"battle-of-las-piedras": "Las Piedras Savaşı",
	"president-ho-chi-minh-s-birthday": "Ho Chi Minh'in Doğum Günü",
	"national-defense-day": "Milli Savunma Günü",
	"bulgarian-education-and-culture-and-slavonic-literature-day": "Bulgar Eğitim, Kültür ve Slav Edebiyatı Günü",
	"the-battle-of-pichincha": "Pichincha Savaşı",
	"eid-al-ghadeer": "Gadir Bayramı",
	"jour-de-l-afrique": "Afrika Günü",
	"id-ul-alha-hadji-festival-day": "Kurban Bayramı",
	"youm-e-takbeer": "Yevm-i Tekbir",
	"adhi-poson-full-moon-poya-day": "Adhi Poson Dolunay Poya Günü",
	"day-of-the-romanians-everywhere-romanian-businessperson-day": "Dünya Romenleri Günü",
	"spring-bank-holiday": "Bahar Tatili",
	"the-day-of-protection-of-children-rights": "Çocuk Haklarını Koruma Günü",
	"pancasila-day": "Pancasila Günü",
	"madaraka-day": "Madaraka Günü",
	"international-children-s-day": "Dünya Çocuk Günü",
	"queen-suthida-s-birthday": "Kraliçe Suthida'nın Doğum Günü",
	"martyr-s-day": "Şehitler Günü",
	"national-flag-day": "Milli Bayrak Günü",
	"day-of-national-unity": "Milli Birlik Günü",
	"jerusalem-day-yom-yerushalayim": "Kudüs Günü (Yom Yeruşalayim)",
	"imam-khomeini-s-demise": "İmam Humeyni'nin Vefatı",
	"revolt-of-khordad-15": "15 Hordad Ayaklanması",
	vatertag: "Babalar Günü",
	"first-monday-in-june": "Haziran'ın İlk Pazartesisi",
	"june-7th": "7 Haziran",
	"yang-di-pertuan-agong-s-birthday": "Yang di-Pertuan Agong'un Doğum Günü",
	"battle-of-arica-and-flag-day": "Arica Savaşı ve Bayrak Günü",
	"primoz-trubar-day": "Primož Trubar Günü",
	"tuen-ng-festival": "Ejderha Teknesi Festivali",
	"mid-year-festival": "Yıl Ortası Festivali",
	"fete-de-la-commemoration-de-la-conference-nationale-souveraine": "Ulusal Egemenlik Konferansı Anma Günü",
	"portugal-day": "Portekiz Günü",
	"shavuot-feast-of-weeks": "Şavuot (Haftalar Bayramı)",
	"democracy-day": "Demokrasi Günü",
	"day-of-struggle-and-martyrdom-of-the-polish-villages": "Polonya Köylerinin Mücadele ve Şehadet Günü",
	"chaco-armistice": "Chaco Ateşkesi",
	"day-of-mourning-and-commemoration": "Yas ve Anma Günü",
	tasoua: "Tasua",
	ashura: "Aşure Günü",
	"national-salvation-day": "Milli Kurtuluş Günü",
	ashoura: "Aşure Günü",
	"day-of-the-independent-hungary": "Bağımsız Macaristan Günü",
	"birthday-of-jose-gervasio-artigas-and-never-again-day": "José Gervasio Artigas'ın Doğum Günü",
	"andean-amazonian-chaqueno-new-year": "And-Amazon Yeni Yılı",
	"anti-fascist-struggle-day": "Faşizme Karşı Mücadele Günü",
	"midsummer-eve": "Yaz Ortası Arifesi",
	midsummer: "Yaz Ortası",
	"battle-of-carabobo": "Carabobo Savaşı",
	"azerbaijan-armed-forces-day": "Azerbaycan Silahlı Kuvvetler Günü",
	"saint-vitus-day": "Aziz Vitus Günü",
	"vietnamese-family-day": "Vietnam Aile Günü",
	"poson-full-moon-poya-day": "Poson Dolunay Poya Günü",
	"sir-seretse-khama-day": "Sir Seretse Khama Günü",
	"hong-kong-special-administrative-region-establishment-day": "Hong Kong ÖİB Kuruluş Günü",
	"jan-hus-day": "Jan Hus Günü",
	"capital-city-day": "Başkent Günü",
	"nelson-mandela-day": "Nelson Mandela Günü",
	"president-s-day": "Başkanlık Günü",
	"birthday-of-don-luis-munoz-rivera": "Luis Muñoz Rivera'nın Doğum Günü",
	"president-s-day-holiday": "Başkanlık Günü Tatili",
	"seventeenth-of-tamuz-fast": "Tamuz'un On Yedisi (Oruç)",
	"peruvian-air-force-day": "Peru Hava Kuvvetleri Günü",
	"the-birthday-of-simon-bolivar": "Simón Bolívar'ın Doğum Günü",
	"arbaeen-e-hosseini": "Erbain",
	"birthday-of-simon-bolivar": "Simón Bolívar'ın Doğum Günü",
	"guanacaste-day": "Guanacaste Günü",
	"puerto-rico-constitution-day": "Porto Riko Anayasa Günü",
	"birthday-of-dr-jose-celso-barbosa": "Dr. José Celso Barbosa'nın Doğum Günü",
	"st-olav-s-eve": "Aziz Olav Arifesi",
	"king-s-birthday": "Kralın Doğum Günü",
	"st-olav-s-day": "Aziz Olav Günü",
	"esala-full-moon-poya-day": "Esala Dolunay Poya Günü",
	"national-anthem-day": "Milli Marş Günü",
	"parents-day": "Ebeveynler Günü",
	bundesfeiertag: "Milli Bayram",
	"demise-of-prophet-muhammad-and-imam-hassan-mujtaba": "Hz. Muhammed ve İmam Hasan'ın Vefatı",
	"national-warsaw-uprising-remembrance-day": "Varşova Ayaklanması Anma Günü",
	"kadooment-day": "Kadooment Günü",
	"our-lady-of-los-angeles": "Los Ángeles Meryem Anası",
	"first-monday-in-august": "Ağustos'un İlk Pazartesisi",
	"day-of-the-republic": "Cumhuriyet Günü",
	"jabotinsky-day": "Jabotinsky Günü",
	"martyrdom-of-imam-reza": "İmam Rıza'nın Şehadeti",
	"founders-day": "Kurucular Günü",
	"victory-and-homeland-thanksgiving-day-and-the-day-of-croatian-defenders": "Zafer ve Vatan Şükran Günü",
	"battle-of-junin": "Junín Savaşı",
	"national-women-s-day": "Milli Kadınlar Günü",
	"declaration-of-independence-of-quito": "Quito Bağımsızlık Bildirgesi",
	"martyrdom-of-imam-hassan": "İmam Hasan'ın Şehadeti",
	"defence-forces-day": "Savunma Kuvvetleri Günü",
	"tisha-b-av-fast": "Tişa BeAv (Oruç)",
	"the-queen-mother-s-birthday": "Kraliçe Anne'nin Doğum Günü",
	"ghost-festival": "Hayalet Festivali",
	"unification-of-prekmurje-slovenes-with-the-mother-nation": "Prekmurje Slovenlerinin Anavatanla Birleşmesi",
	"tu-b-av-fifteenth-of-av": "Tu BeAv",
	"birthday-of-muhammad-prophet": "Mevlid Kandili",
	"august-revolution-commemoration-day": "Ağustos Devrimi Anma Günü",
	"day-of-restoration-of-independence": "Bağımsızlığın Yeniden Kazanılması Günü",
	"european-day-of-remembrance-for-victims-of-stalinism-and-nazism": "Stalinizm ve Nazizm Kurbanlarını Anma Günü",
	"milad-un-nabi-holy-prophet-s-birthday": "Mevlid Kandili",
	"nikini-full-moon-poya-day": "Nikini Dolunay Poya Günü",
	"slovak-national-uprising-anniversary": "Slovak Ulusal Ayaklanması Yıl Dönümü",
	"santa-rosa-de-lima": "Limalı Azize Rosa",
	"day-of-solidarity-and-freedom": "Dayanışma ve Özgürlük Günü",
	"knowledge-literacy-and-education-day": "Bilgi, Okuryazarlık ve Eğitim Günü",
	"anniversary-of-the-outbreak-of-the-second-world-war-in-poland": "II. Dünya Savaşı'nın Başlangıcı Yıl Dönümü",
	"ganesh-chaturthi": "Ganeş Çaturti",
	"unification-day": "Birleşme Günü",
	"lusaka-peace-agreement": "Lusaka Barış Anlaşması",
	"independence-of-guayaquil": "Guayaquil'in Bağımsızlığı",
	"our-lady-of-coromoto": "Coromoto Meryem Anası",
	"grandparents-day": "Büyükanne ve Büyükbaba Günü",
	"return-of-primorska-to-the-motherland": "Primorska'nın Anavatana Dönüşü",
	"day-of-our-lady-of-the-seven-sorrows": "Yedi Acılar Meryem Anası Günü",
	"malaysia-day": "Malezya Günü",
	"national-hero-day": "Milli Kahraman Günü",
	"anniversary-of-the-soviet-invasion-of-poland": "Sovyet İşgali Yıl Dönümü",
	"federal-day-of-thanksgiving-repentance-and-prayer": "Federal Şükran, Tövbe ve Dua Günü",
	"prince-s-day": "Prens Günü",
};

const RAW_TR_NAMES: Readonly<Record<string, string>> = {
	"عيد الجلاء": "Tahliye Bayramı",
	"عيد الثورة و الشباب": "Devrim ve Gençlik Bayramı",
	"عيد الإستقلال": "Bağımsızlık Bayramı",
	"عيد الشهداء": "Şehitler Bayramı",
	"عيد الجمهورية": "Cumhuriyet Bayramı",
	"عيد المرأة": "Kadınlar Bayramı",
};

export function localizedSpecialDayName(name: string, lang: string): string {
	if (!lang.startsWith("tr")) return name;
	const raw = RAW_TR_NAMES[name.trim()];
	if (raw) return raw;
	const key = specialDayKey(name);
	if (!key) return name;
	return TR_NAMES[key] ?? name;
}
